<div class="selection-section _18px">
  <div>
    <div class="rift-soft">{{ label }}</div>
  </div>
  <div class="selection-wrapper">
    <div class="cnt-button-icon subtraction" (click)="onDecrement()">
      <div class="html-embed w-embed">
        <svg width="17px" height="17px" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Group">
              <g id="Ellipse_37">
                <circle id="Oval" fill="#FFFFFF" fill-rule="nonzero" cx="8.5" cy="8.5" r="8.5"></circle>
                <circle id="Oval" stroke="#454545" cx="8.5" cy="8.5" r="8"></circle>
              </g>
              <g id="Group_3741" transform="translate(6.161000, 8.004000)" stroke="#454545" stroke-linecap="round">
                <line x1="4.9" y1="0.5" x2="0" y2="0.5" id="Path_5600"></line>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div class="number">
      <div class="_24-px-font-2">{{ value }}</div>
    </div>
    <div class="cnt-button-icon addition" (click)="onIncrement()">
      <div class="html-embed w-embed">
        <svg width="17px" height="17px" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Group">
              <g id="Ellipse_37">
                <circle id="Oval" fill="#FFFFFF" fill-rule="nonzero" cx="8.5" cy="8.5" r="8.5"></circle>
                <circle id="Oval" stroke="#454545" cx="8.5" cy="8.5" r="8"></circle>
              </g>
              <g id="Group_3741" transform="translate(6.161000, 6.104000)" stroke="#454545" stroke-linecap="round">
                <line x1="2.4" y1="0" x2="2.4" y2="4.9" id="Line_3"></line>
                <line x1="4.9" y1="2.4" x2="0" y2="2.4" id="Path_5600"></line>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
</div>
